module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-root"
  }, [(_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jd-header"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "jd-create-btn",
    on: {
      "click": _vm.openCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Create journey default\n    ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "jd-toolbar"
  }, [_c('div', {
    staticClass: "jd-search-wrap"
  }, [_c('i', {
    staticClass: "fa fa-search jd-search-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "jd-search-input",
    attrs: {
      "type": "text",
      "placeholder": "Search journeys..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-filter-select",
    model: {
      value: (_vm.filterCountry),
      callback: function($$v) {
        _vm.filterCountry = $$v
      },
      expression: "filterCountry"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All countries")]), _vm._v(" "), _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-filter-select",
    model: {
      value: (_vm.filterClient),
      callback: function($$v) {
        _vm.filterClient = $$v
      },
      expression: "filterClient"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All customers")]), _vm._v(" "), _vm._l((_vm.clients), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-table-wrap"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "jd-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Loading journey defaults...")])]) : (_vm.filteredGroups.length === 0) ? _c('div', {
    staticClass: "jd-empty"
  }, [_vm._v("\n      No journey defaults found.\n    ")]) : _c('table', {
    staticClass: "jd-table"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.filteredGroups), function(group) {
    return _c('tbody', {
      key: group.key
    }, [_c('tr', {
      staticClass: "jd-group-row"
    }, [_c('td', {
      staticClass: "jd-group-cell",
      attrs: {
        "colspan": "24"
      }
    }, [(group.countryFlag) ? _c('span', {
      staticClass: "jd-flag"
    }, [_vm._v(_vm._s(group.countryFlag))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "jd-group-label"
    }, [_vm._v(_vm._s(group.countryName) + " › " + _vm._s(group.clientName))])])]), _vm._v(" "), _vm._l((group.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "jd-row",
        class: {
          'jd-row--dirty': _vm.isDirty(row.id)
        }
      }, [_c('td', {
        staticClass: "jd-td jd-td-name"
      }, [_vm._v(_vm._s(row.journeyName))]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-prefix"
      }, [(_vm.editingPrefix !== row.id) ? _c('div', {
        staticClass: "jd-prefix-display"
      }, [_c('span', {
        staticClass: "jd-prefix-badge"
      }, [_vm._v(_vm._s(row.default_data.keyword_prefix))]), _vm._v(" "), _c('button', {
        staticClass: "jd-prefix-edit-btn",
        attrs: {
          "title": "Edit prefix"
        },
        on: {
          "click": function($event) {
            return _vm.startEditPrefix(row)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]) : _c('div', {
        staticClass: "jd-prefix-edit-wrap"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.prefixDraft),
          expression: "prefixDraft"
        }],
        ref: 'prefix-' + row.id,
        refInFor: true,
        staticClass: "jd-prefix-input",
        attrs: {
          "maxlength": "40"
        },
        domProps: {
          "value": (_vm.prefixDraft)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.prefixDraft = $event.target.value
          }, function($event) {
            _vm.prefixDraft = _vm.prefixDraft.toLowerCase().replace(/[^a-z0-9_-]/g, '')
          }],
          "keyup": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.confirmPrefix(row)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.cancelPrefix.apply(null, arguments)
          }]
        }
      }), _vm._v(" "), _c('button', {
        staticClass: "jd-prefix-confirm-btn",
        attrs: {
          "title": "Confirm"
        },
        on: {
          "click": function($event) {
            return _vm.confirmPrefix(row)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check"
      })]), _vm._v(" "), _c('button', {
        staticClass: "jd-prefix-cancel-btn",
        attrs: {
          "title": "Cancel"
        },
        on: {
          "click": _vm.cancelPrefix
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.onRowOnboardingChange(row)
          }
        },
        model: {
          value: (row.default_data.onboarding_mode),
          callback: function($$v) {
            _vm.$set(row.default_data, "onboarding_mode", $$v)
          },
          expression: "row.default_data.onboarding_mode"
        }
      }, [_c('option', {
        attrs: {
          "value": "regular"
        }
      }, [_vm._v("Regular")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "gen_ai"
        }
      }, [_vm._v("Gen AI")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "skip"
        }
      }, [_vm._v("Skip")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-prompt"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        attrs: {
          "disabled": row.default_data.onboarding_mode !== 'gen_ai'
        },
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.prompt_id),
          callback: function($$v) {
            _vm.$set(row.default_data, "prompt_id", $$v)
          },
          expression: "row.default_data.prompt_id"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("— none —")]), _vm._v(" "), _vm._l((_vm.promptList), function(p) {
        return _c('option', {
          key: p.id,
          domProps: {
            "value": p.id
          }
        }, [_vm._v(_vm._s(p.label))])
      })], 2)], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-bool"
      }, [_c('span', {
        staticClass: "jd-toggle",
        class: {
          'jd-toggle--on': row.default_data.nlp_question
        },
        on: {
          "click": function($event) {
            return _vm.toggle(row, 'nlp_question')
          }
        }
      }, [_c('span', {
        staticClass: "jd-toggle-knob"
      })])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-bool"
      }, [_c('span', {
        staticClass: "jd-toggle",
        class: {
          'jd-toggle--on': row.default_data.auto_accept_tc
        },
        on: {
          "click": function($event) {
            return _vm.toggle(row, 'auto_accept_tc')
          }
        }
      }, [_c('span', {
        staticClass: "jd-toggle-knob"
      })])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-bool"
      }, [_c('span', {
        staticClass: "jd-toggle",
        class: {
          'jd-toggle--on': row.default_data.club_optin
        },
        on: {
          "click": function($event) {
            return _vm.toggle(row, 'club_optin')
          }
        }
      }, [_c('span', {
        staticClass: "jd-toggle-knob"
      })])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.default_gender),
          callback: function($$v) {
            _vm.$set(row.default_data, "default_gender", $$v)
          },
          expression: "row.default_data.default_gender"
        }
      }, [_c('option', {
        attrs: {
          "value": "ask_user"
        }
      }, [_vm._v("Ask user")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "female"
        }
      }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "male"
        }
      }, [_vm._v("Male")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.referral_priority),
          callback: function($$v) {
            _vm.$set(row.default_data, "referral_priority", $$v)
          },
          expression: "row.default_data.referral_priority"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("No priority")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "high"
        }
      }, [_vm._v("High")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "medium"
        }
      }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "low"
        }
      }, [_vm._v("Low")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.ownership_filter),
          callback: function($$v) {
            _vm.$set(row.default_data, "ownership_filter", $$v)
          },
          expression: "row.default_data.ownership_filter"
        }
      }, [_c('option', {
        attrs: {
          "value": "all"
        }
      }, [_vm._v("All")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "public"
        }
      }, [_vm._v("Public")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "private"
        }
      }, [_vm._v("Private")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.physical_virtual_medical_filter),
          callback: function($$v) {
            _vm.$set(row.default_data, "physical_virtual_medical_filter", $$v)
          },
          expression: "row.default_data.physical_virtual_medical_filter"
        }
      }, [_c('option', {
        attrs: {
          "value": "all"
        }
      }, [_vm._v("All")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "physical"
        }
      }, [_vm._v("Physical")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "virtual"
        }
      }, [_vm._v("Virtual")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "medical"
        }
      }, [_vm._v("Medical")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.medical_filter),
          callback: function($$v) {
            _vm.$set(row.default_data, "medical_filter", $$v)
          },
          expression: "row.default_data.medical_filter"
        }
      }, [_c('option', {
        attrs: {
          "value": "all"
        }
      }, [_vm._v("All")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "medical"
        }
      }, [_vm._v("Medical")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "pharmacy"
        }
      }, [_vm._v("Pharmacy")])])], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-bool"
      }, [_c('span', {
        staticClass: "jd-toggle",
        class: {
          'jd-toggle--on': row.default_data.is_qr_code
        },
        on: {
          "click": function($event) {
            return _vm.toggle(row, 'is_qr_code')
          }
        }
      }, [_c('span', {
        staticClass: "jd-toggle-knob"
      })])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-bool"
      }, [_c('span', {
        staticClass: "jd-toggle",
        class: {
          'jd-toggle--on': row.default_data.send_referral_code
        },
        on: {
          "click": function($event) {
            return _vm.toggle(row, 'send_referral_code')
          }
        }
      }, [_c('span', {
        staticClass: "jd-toggle-knob"
      })])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row.default_data.utm_source),
          expression: "row.default_data.utm_source"
        }],
        staticClass: "jd-input",
        attrs: {
          "type": "text",
          "placeholder": "UTM source"
        },
        domProps: {
          "value": (row.default_data.utm_source)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row.default_data, "utm_source", $event.target.value)
          }, function($event) {
            return _vm.markDirty(row.id)
          }]
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row.default_data.utm_medium),
          expression: "row.default_data.utm_medium"
        }],
        staticClass: "jd-input",
        attrs: {
          "type": "text",
          "placeholder": "UTM medium"
        },
        domProps: {
          "value": (row.default_data.utm_medium)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row.default_data, "utm_medium", $event.target.value)
          }, function($event) {
            return _vm.markDirty(row.id)
          }]
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.channel),
          callback: function($$v) {
            _vm.$set(row.default_data, "channel", $$v)
          },
          expression: "row.default_data.channel"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("--Choose a Channel--")]), _vm._v(" "), _vm._l((_vm.channels), function(ch) {
        return _c('option', {
          key: ch.value,
          domProps: {
            "value": ch.value
          }
        }, [_vm._v(_vm._s(ch.name))])
      })], 2)], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row.default_data.tag),
          expression: "row.default_data.tag"
        }],
        staticClass: "jd-input",
        attrs: {
          "type": "text",
          "placeholder": "Tag"
        },
        domProps: {
          "value": (row.default_data.tag)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row.default_data, "tag", $event.target.value)
          }, function($event) {
            return _vm.markDirty(row.id)
          }]
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.keyword_usage),
          callback: function($$v) {
            _vm.$set(row.default_data, "keyword_usage", $$v)
          },
          expression: "row.default_data.keyword_usage"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.keywordUsageList), function(opt) {
        return _c('option', {
          key: opt.usage_type,
          domProps: {
            "value": opt.usage_type
          }
        }, [_vm._v(_vm._s(opt.labels))])
      })], 2)], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.topic),
          callback: function($$v) {
            _vm.$set(row.default_data, "topic", $$v)
          },
          expression: "row.default_data.topic"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.topicList), function(opt) {
        return _c('option', {
          key: opt.display_name,
          domProps: {
            "value": opt.display_name
          }
        }, [_vm._v(_vm._s(opt.display_name))])
      })], 2)], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('nv-select', {
        staticClass: "jd-select",
        on: {
          "change": function($event) {
            return _vm.markDirty(row.id)
          }
        },
        model: {
          value: (row.default_data.scout_menu),
          callback: function($$v) {
            _vm.$set(row.default_data, "scout_menu", $$v)
          },
          expression: "row.default_data.scout_menu"
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("--Choose a Journey--")]), _vm._v(" "), _vm._l((_vm.journeys), function(j) {
        return _c('option', {
          key: j.id,
          domProps: {
            "value": j.name
          }
        }, [_vm._v(_vm._s(j.name))])
      })], 2)], 1), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-wide"
      }, [_c('button', {
        staticClass: "jd-show-messages-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.openWelcomeMessagesModal(row.country_id, row.default_data.custom_config, function (result) {
              _vm.$set(row.default_data, 'custom_messages', result.custom_messages);
              _vm.$set(row.default_data, 'custom_config', result.custom_config);
              _vm.markDirty(row.id)
            })
          }
        }
      }, [_vm._v("Show Messages")])]), _vm._v(" "), _c('td', {
        staticClass: "jd-td jd-td-actions"
      }, [(_vm.deletingId !== row.id) ? _c('button', {
        staticClass: "jd-delete-btn",
        attrs: {
          "title": "Delete journey default"
        },
        on: {
          "click": function($event) {
            return _vm.confirmDelete(row)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _c('span', {
        staticClass: "jd-delete-confirm"
      }, [_c('span', {
        staticClass: "jd-delete-confirm-text"
      }, [_vm._v("Delete?")]), _vm._v(" "), _c('button', {
        staticClass: "jd-delete-confirm-yes",
        attrs: {
          "disabled": _vm.deleteInProgress
        },
        on: {
          "click": function($event) {
            return _vm.executeDelete(row)
          }
        }
      }, [(_vm.deleteInProgress) ? _c('i', {
        staticClass: "fa fa-spinner fa-spin"
      }) : _c('i', {
        staticClass: "fa fa-check"
      })]), _vm._v(" "), _c('button', {
        staticClass: "jd-delete-confirm-no",
        attrs: {
          "disabled": _vm.deleteInProgress
        },
        on: {
          "click": _vm.cancelDelete
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])])])])
    })], 2)
  })], 2)]), _vm._v(" "), (_vm.dirtyIds.size > 0) ? _c('div', {
    staticClass: "jd-footer"
  }, [_c('span', {
    staticClass: "jd-dirty-count"
  }, [_vm._v(_vm._s(_vm.dirtyIds.size) + " unsaved change" + _vm._s(_vm.dirtyIds.size !== 1 ? 's' : ''))]), _vm._v(" "), _c('button', {
    staticClass: "jd-discard-btn",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.discardChanges
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "jd-save-btn",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [(_vm.saving) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.saving ? 'Saving...' : 'Save defaults') + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "jd-modal-fade"
    }
  }, [(_vm.showCreateModal) ? _c('div', {
    staticClass: "jd-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeCreateModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "jd-modal"
  }, [_c('div', {
    staticClass: "jd-modal-header"
  }, [_c('h3', {
    staticClass: "jd-modal-title"
  }, [_vm._v("Create journey default")]), _vm._v(" "), _c('button', {
    staticClass: "jd-modal-close",
    on: {
      "click": _vm.closeCreateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-modal-body"
  }, [_c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Journey")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Country "), _c('span', {
    staticClass: "jd-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    on: {
      "change": _vm.onCreateCountryChange
    },
    model: {
      value: (_vm.createForm.country_id),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "country_id", $$v)
      },
      expression: "createForm.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select country...")]), _vm._v(" "), _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Client "), _c('span', {
    staticClass: "jd-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    attrs: {
      "disabled": !_vm.createForm.country_id
    },
    on: {
      "change": _vm.onCreateClientChange
    },
    model: {
      value: (_vm.createForm.client_id),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "client_id", $$v)
      },
      expression: "createForm.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select client...")]), _vm._v(" "), _vm._l((_vm.filteredCreateClients), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Journey "), _c('span', {
    staticClass: "jd-required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    attrs: {
      "disabled": !_vm.createForm.client_id
    },
    on: {
      "change": _vm.onCreateJourneyChange
    },
    model: {
      value: (_vm.createForm.journey_id),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "journey_id", $$v)
      },
      expression: "createForm.journey_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select journey...")]), _vm._v(" "), _vm._l((_vm.filteredCreateJourneys), function(j) {
    return _c('option', {
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Keyword Prefix "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(auto-generated, editable)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.keyword_prefix),
      expression: "createForm.keyword_prefix"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "maxlength": "40",
      "placeholder": "e.g. con_met_sel"
    },
    domProps: {
      "value": (_vm.createForm.keyword_prefix)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "keyword_prefix", $event.target.value)
      }, function($event) {
        _vm.createForm.keyword_prefix = _vm.createForm.keyword_prefix.toLowerCase().replace(/[^a-z0-9_-]/g, '')
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Onboarding Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Onboarding Mode")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    on: {
      "change": _vm.onCreateOnboardingChange
    },
    model: {
      value: (_vm.createForm.onboarding_mode),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "onboarding_mode", $$v)
      },
      expression: "createForm.onboarding_mode"
    }
  }, [_c('option', {
    attrs: {
      "value": "regular"
    }
  }, [_vm._v("Regular")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gen_ai"
    }
  }, [_vm._v("Gen AI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "skip"
    }
  }, [_vm._v("Skip")])])], 1), _vm._v(" "), (_vm.createForm.onboarding_mode === 'gen_ai') ? _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("GenAI Prompt")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.prompt_id),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "prompt_id", $$v)
      },
      expression: "createForm.prompt_id"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select prompt...")]), _vm._v(" "), _vm._l((_vm.promptList), function(p) {
    return _c('option', {
      key: p.id,
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.createForm.onboarding_mode === 'gen_ai') ? _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("GenAI Ad Context")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.ad_context),
      expression: "createForm.ad_context"
    }],
    staticClass: "jd-form-select jd-form-textarea",
    attrs: {
      "placeholder": "Enter keyword context for GenAI",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.createForm.ad_context)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "ad_context", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.createForm.onboarding_mode === 'gen_ai') ? _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Underage Limit "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(1–99)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.underage_limit),
      expression: "createForm.underage_limit"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "Enter lower age limit"
    },
    domProps: {
      "value": (_vm.createForm.underage_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "underage_limit", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Jump State "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(conversation stage)")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    attrs: {
      "disabled": !_vm.createForm.journey_id || _vm.createJourneyStages.length === 0
    },
    model: {
      value: (_vm.createForm.jump_state),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "jump_state", $$v)
      },
      expression: "createForm.jump_state"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— none —")]), _vm._v(" "), _vm._l((_vm.createJourneyStages), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": s.id
      }
    }, [_vm._v(_vm._s(s.label))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Default Language "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(auto-set by country)")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    attrs: {
      "disabled": !_vm.createForm.country_id
    },
    model: {
      value: (_vm.createForm.default_language),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "default_language", $$v)
      },
      expression: "createForm.default_language"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select language...")]), _vm._v(" "), _vm._l((_vm.createLanguageOptions), function(l) {
    return _c('option', {
      key: l.value,
      domProps: {
        "value": l.value
      }
    }, [_vm._v(_vm._s(l.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.set_preferred_user_language),
      expression: "createForm.set_preferred_user_language"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.set_preferred_user_language) ? _vm._i(_vm.createForm.set_preferred_user_language, null) > -1 : (_vm.createForm.set_preferred_user_language)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.set_preferred_user_language,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "set_preferred_user_language", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "set_preferred_user_language", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "set_preferred_user_language", $$c)
        }
      }
    }
  }), _vm._v("\n              Set preferred user language "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(skip language question during onboarding)")])])]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.nlp_question),
      expression: "createForm.nlp_question"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.nlp_question) ? _vm._i(_vm.createForm.nlp_question, null) > -1 : (_vm.createForm.nlp_question)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.nlp_question,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "nlp_question", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "nlp_question", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "nlp_question", $$c)
        }
      }
    }
  }), _vm._v("\n              Enable NLP based onboarding question\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.auto_accept_tc),
      expression: "createForm.auto_accept_tc"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.auto_accept_tc) ? _vm._i(_vm.createForm.auto_accept_tc, null) > -1 : (_vm.createForm.auto_accept_tc)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.auto_accept_tc,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "auto_accept_tc", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "auto_accept_tc", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "auto_accept_tc", $$c)
        }
      }
    }
  }), _vm._v("\n              Auto-accept Terms & Conditions\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.club_optin),
      expression: "createForm.club_optin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.club_optin) ? _vm._i(_vm.createForm.club_optin, null) > -1 : (_vm.createForm.club_optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.club_optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "club_optin", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "club_optin", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "club_optin", $$c)
        }
      }
    }
  }), _vm._v("\n              Club OptIn and Language Question\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Default Gender")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.default_gender),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "default_gender", $$v)
      },
      expression: "createForm.default_gender"
    }
  }, [_c('option', {
    attrs: {
      "value": "ask_user"
    }
  }, [_vm._v("Ask user")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Referral Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Referral Display Priority")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.referral_priority),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "referral_priority", $$v)
      },
      expression: "createForm.referral_priority"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("No priority")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "high"
    }
  }, [_vm._v("High")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "medium"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "low"
    }
  }, [_vm._v("Low")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Ownership Filter")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.ownership_filter),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "ownership_filter", $$v)
      },
      expression: "createForm.ownership_filter"
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "public"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "private"
    }
  }, [_vm._v("Private")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Physical / Virtual Filter")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.physical_virtual_medical_filter),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "physical_virtual_medical_filter", $$v)
      },
      expression: "createForm.physical_virtual_medical_filter"
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "physical"
    }
  }, [_vm._v("Physical")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "virtual"
    }
  }, [_vm._v("Virtual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "medical"
    }
  }, [_vm._v("Medical")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Medical / Pharmacy Filter")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.medical_filter),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "medical_filter", $$v)
      },
      expression: "createForm.medical_filter"
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "medical"
    }
  }, [_vm._v("Medical")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pharmacy"
    }
  }, [_vm._v("Pharmacy")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.is_qr_code),
      expression: "createForm.is_qr_code"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.is_qr_code) ? _vm._i(_vm.createForm.is_qr_code, null) > -1 : (_vm.createForm.is_qr_code)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.is_qr_code,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "is_qr_code", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "is_qr_code", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "is_qr_code", $$c)
        }
      }
    }
  }), _vm._v("\n              QR code available\n            ")])]), _vm._v(" "), (_vm.createForm.is_qr_code) ? _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("QR Code Placement")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.qr_code_placement),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "qr_code_placement", $$v)
      },
      expression: "createForm.qr_code_placement"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— none —")]), _vm._v(" "), _vm._l((_vm.qrCodePlacementOptions), function(opt) {
    return _c('option', {
      key: opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.send_referral_code),
      expression: "createForm.send_referral_code"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.send_referral_code) ? _vm._i(_vm.createForm.send_referral_code, null) > -1 : (_vm.createForm.send_referral_code)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.send_referral_code,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "send_referral_code", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "send_referral_code", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "send_referral_code", $$c)
        }
      }
    }
  }), _vm._v("\n              Send Referral Code\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Campaign / UTM")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("UTM Source")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.utm_source),
      expression: "createForm.utm_source"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "type": "text",
      "placeholder": "e.g. google"
    },
    domProps: {
      "value": (_vm.createForm.utm_source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "utm_source", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("UTM Medium")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.utm_medium),
      expression: "createForm.utm_medium"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "type": "text",
      "placeholder": "e.g. cpc"
    },
    domProps: {
      "value": (_vm.createForm.utm_medium)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "utm_medium", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("UTM Campaign")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.utm_campaign),
      expression: "createForm.utm_campaign"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "type": "text",
      "placeholder": "e.g. spring_sale"
    },
    domProps: {
      "value": (_vm.createForm.utm_campaign)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "utm_campaign", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Keyword Metadata")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Channel")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.channel),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "channel", $$v)
      },
      expression: "createForm.channel"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--Choose a Channel--")]), _vm._v(" "), _vm._l((_vm.channels), function(ch) {
    return _c('option', {
      key: ch.value,
      domProps: {
        "value": ch.value
      }
    }, [_vm._v(_vm._s(ch.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.tag),
      expression: "createForm.tag"
    }],
    staticClass: "jd-form-select",
    attrs: {
      "type": "text",
      "placeholder": "e.g. promo, seasonal"
    },
    domProps: {
      "value": (_vm.createForm.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.createForm, "tag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Keyword Usage")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.keyword_usage),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "keyword_usage", $$v)
      },
      expression: "createForm.keyword_usage"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— select —")]), _vm._v(" "), _vm._l((_vm.keywordUsageList), function(opt) {
    return _c('option', {
      key: opt.usage_type,
      domProps: {
        "value": opt.usage_type
      }
    }, [_vm._v(_vm._s(opt.labels))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Keyword Topic")]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.topic),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "topic", $$v)
      },
      expression: "createForm.topic"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— select —")]), _vm._v(" "), _vm._l((_vm.topicList), function(opt) {
    return _c('option', {
      key: opt.display_name,
      domProps: {
        "value": opt.display_name
      }
    }, [_vm._v(_vm._s(opt.display_name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label"
  }, [_vm._v("Scout Menu "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v("(journey to hand off to)")])]), _vm._v(" "), _c('nv-select', {
    staticClass: "jd-form-select",
    model: {
      value: (_vm.createForm.scout_menu),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "scout_menu", $$v)
      },
      expression: "createForm.scout_menu"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— none —")]), _vm._v(" "), _vm._l((_vm.journeys), function(j) {
    return _c('option', {
      key: j.id,
      domProps: {
        "value": j.name
      }
    }, [_vm._v(_vm._s(j.name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "jd-form-section-label"
  }, [_vm._v("Default Welcome Messages")]), _vm._v(" "), _c('div', {
    staticClass: "jd-form-group"
  }, [_c('label', {
    staticClass: "jd-form-label jd-form-label--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createForm.custom_messages),
      expression: "createForm.custom_messages"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "yes",
      "false-value": "no"
    },
    domProps: {
      "checked": Array.isArray(_vm.createForm.custom_messages) ? _vm._i(_vm.createForm.custom_messages, null) > -1 : _vm._q(_vm.createForm.custom_messages, "yes")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createForm.custom_messages,
          $$el = $event.target,
          $$c = $$el.checked ? ("yes") : ("no");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createForm, "custom_messages", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createForm, "custom_messages", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createForm, "custom_messages", $$c)
        }
      }
    }
  }), _vm._v("\n              Use Custom Welcome Messages\n            ")])]), _vm._v(" "), (_vm.createForm.custom_messages === 'yes') ? _c('div', {
    staticClass: "jd-form-group jd-form-group--row"
  }, [_c('button', {
    staticClass: "jd-show-messages-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openWelcomeMessagesModal(_vm.createForm.country_id, _vm.createForm.custom_config, function (result) {
          _vm.createForm.custom_messages = result.custom_messages;
          _vm.createForm.custom_config = result.custom_config
        })
      }
    }
  }, [_vm._v("Show Messages")]), _vm._v(" "), _c('span', {
    staticClass: "jd-form-hint"
  }, [_vm._v(_vm._s(Object.keys(_vm.createForm.custom_config || {}).length) + " language(s) configured")])]) : _vm._e(), _vm._v(" "), (_vm.createError) ? _c('p', {
    staticClass: "jd-form-error"
  }, [_vm._v(_vm._s(_vm.createError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "jd-modal-footer"
  }, [_c('button', {
    staticClass: "jd-discard-btn",
    attrs: {
      "disabled": _vm.creating
    },
    on: {
      "click": _vm.closeCreateModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "jd-save-btn",
    attrs: {
      "disabled": _vm.creating || !_vm.createFormValid
    },
    on: {
      "click": _vm.submitCreate
    }
  }, [(_vm.creating) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.creating ? 'Creating...' : 'Create') + "\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "jd-modal-fade"
    }
  }, [(_vm.showWelcomeModal) ? _c('div', {
    staticClass: "jd-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeWelcomeMessagesModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "jd-modal"
  }, [_c('div', {
    staticClass: "jd-modal-header"
  }, [_c('h3', {
    staticClass: "jd-modal-title"
  }, [_vm._v("New User Welcome Message")]), _vm._v(" "), _c('button', {
    staticClass: "jd-modal-close",
    on: {
      "click": _vm.closeWelcomeMessagesModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-modal-body"
  }, [(_vm.welcomeModalNoLanguageData) ? _c('p', {
    staticClass: "jd-form-hint jd-form-hint--block"
  }, [_vm._v("\n            No additional languages are configured for this country yet — you can still set the English welcome message below.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.welcomeModalRows[0]) ? _c('table', {
    staticClass: "jd-msg-table"
  }, [_c('tbody', _vm._l((_vm.welcomeModalRows[0].language), function(langRow) {
    return _c('tr', {
      key: langRow.langShortcode
    }, [_c('td', {
      staticClass: "jd-msg-lang"
    }, [_vm._v(_vm._s(langRow.langName))]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (langRow.message),
        expression: "langRow.message"
      }],
      staticClass: "jd-form-select jd-form-textarea",
      attrs: {
        "rows": "3",
        "placeholder": "Message"
      },
      domProps: {
        "value": (langRow.message)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(langRow, "message", $event.target.value)
        }
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "jd-modal-footer"
  }, [_c('button', {
    staticClass: "jd-discard-btn",
    on: {
      "click": _vm.closeWelcomeMessagesModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "jd-save-btn",
    on: {
      "click": _vm.saveWelcomeMessages
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-header-left"
  }, [_c('h2', {
    staticClass: "jd-title"
  }, [_vm._v("Journey defaults")]), _vm._v(" "), _c('p', {
    staticClass: "jd-subtitle"
  }, [_vm._v("Set default keyword configuration per journey. The AI applies these silently and surfaces them in the confirmation summary — users can override in chat.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-banner"
  }, [_c('i', {
    staticClass: "fa fa-info-circle jd-banner-icon"
  }), _vm._v("\n    Journeys are organised by Country › Customer structure. Engineering has created this structure so the AI can narrow down journey selection without requiring users to remember exact names.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "jd-th jd-th-name"
  }, [_vm._v("Journey Name")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-prefix"
  }, [_vm._v("Keyword Prefix")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Onboarding")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-prompt"
  }, [_vm._v("GenAI Prompt")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-bool"
  }, [_vm._v("NLP Question")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-bool"
  }, [_vm._v("Auto-Accept T&C")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-bool"
  }, [_vm._v("Club Optin")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Default Gender")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Referral Priority")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Ownership Filter")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Physical/Virtual")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th"
  }, [_vm._v("Medical/Pharmacy")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-bool"
  }, [_vm._v("QR Code")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-bool"
  }, [_vm._v("Ref Code")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("UTM Source")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("UTM Medium")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Channel")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Keyword Use")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Keyword Topic")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Scout Menu")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-wide"
  }, [_vm._v("Welcome Messages")]), _vm._v(" "), _c('th', {
    staticClass: "jd-th jd-th-actions"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-399c3ecb","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/journey-defaults/JourneyDefaults.vue
// module id = jSos
// module chunks = 1